const BalancePill = ({ label, value, type }) => {
  return (
    <div className={`balance-pill ${type}-pill`}>
      <svg xmlns='http://www.w3.org/2000/svg' width='22' height='22'
        viewBox='0 0 24 24' fill='none' stroke='currentColor'
        strokeWidth='1.8' strokeLinecap='round' strokeLinejoin='round'
        className='wallet-icon'>
        <rect x='2' y='5' width='20' height='14' rx='3' ry='3'></rect>
        <path d='M16 5V3a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v2'></path>
        <circle cx='18' cy='12' r='2'></circle>
      </svg>
      <span className='label'>{label}</span>
      <span className='value'>{value}</span>
    </div>
  );
};

export default BalancePill;
